
import { Box } from '@mui/material';
import '../App.css';
import { BackgroundStyle, BigHeading, ListContainer } from '../assets/style';
import MainContent from '../components/MainContent';
import { dashboardPageName } from '../components/PageName';
import AlertPieChart from '../components/AlertPieChart';
import OverviewWorkerStatusCard from '../components/OverviewWorkerStatus';
import LastestAlertCard from '../components/LatestAlertCard';
import TodayCompletedCard from '../components/TodayCompletedCard';
import { useEffect, useState } from 'react';
import Signalr from '../features/SignalR/SignalR';
import Connector from '../features/SignalR/SignalR'
import * as signalR from "@microsoft/signalr";
import { useGetLatestAlertQuery, useGetCompletedScheduleQuery } from '../features/dashboard/DashboardSlice';
import { useTranslation } from "react-i18next";
import PermitStatusCard from '../components/PermitStatusCard';

const DashboardPage = () => {
    const { t, i18n } = useTranslation();
    const { data: CompletedSchedule } = useGetCompletedScheduleQuery();
    const { data: LastestAlert } = useGetLatestAlertQuery()

    return (
        <MainContent type={dashboardPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <ListContainer>
                    <BigHeading>{t("Dashboard")}</BigHeading>
                    <Box sx={{
                        display: 'flex', flexDirection: 'column', width: '100', padding: 2
                    }}>
                        {/* <div>
                            <h1>Dashboard</h1>
                            {sensorData && (
                                <div>
                                    <h2>Received Sensor Data:</h2>
                                    <p>{sensorData}</p>
                                </div>
                            )}
                        </div> */}
                        <Box sx={{
                            display: 'flex', height: '45%', gap: '20px',
                            "@media (max-width: 800px)": { display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }
                        }}>
                            <Box sx={{ width: '50%', "@media (max-width: 800px)": { width: '100%' } }}>
                                <AlertPieChart data={undefined} />
                            </Box>
                            <Box sx={{ width: '50%', "@media (max-width: 800px)": { width: '100%' } }}>
                                <LastestAlertCard data={LastestAlert} />
                            </Box>
                        </Box>
                        <Box sx={{
                            display: 'flex', height: '45%', marginTop: '10px', gap: '20px',
                            "@media (max-width: 800px)": { display: 'flex', flexDirection: 'column', marginLeft: "0px", width: '100%', height: '100%' }
                        }}>
                            <Box sx={{ width: '0px', flex: '1 0 0%', "@media (max-width: 800px)": { width: '100%' } }}>
                                <OverviewWorkerStatusCard data={undefined} />
                            </Box>
                            <Box sx={{ width: '0px', flex: '1 0 0%', maxHeight: '100%', "@media (max-width: 800px)": { width: '100%' } }}>
                                <PermitStatusCard />
                            </Box>
                        </Box>
                    </Box>
                </ListContainer>
            </BackgroundStyle>
        </MainContent>
    );
};

export default DashboardPage;